import React from "react";
import { IMAGE_BASE_URL } from "../../data/baseURL";
import { useScrollTop } from "../../hook/useScrollTop";

import { AboutDataContext } from "./about";

const Strategy = () => {
  const { about_strategy } = React.useContext(AboutDataContext);
  useScrollTop();

  return (
    <section className="me-35 ms-35 mt-7">
      <div className="my-5">
        <img
          src={`${IMAGE_BASE_URL}/${about_strategy?.image_one}`}
          loading="lazy"
          alt=""
          className="img-fluid"
        />
      </div>

      <h2
        className="fs-28 lh-30 my-4"
        dangerouslySetInnerHTML={{ __html: about_strategy?.title_one }}
      />

      <p
        className="fs-16 lh-30"
        dangerouslySetInnerHTML={{ __html: about_strategy?.description_one }}
      />

      <section className="row my-4 pt-5">
        <div className="col-12 col-md-5">
          <img
            src={`${IMAGE_BASE_URL}/${about_strategy?.image_two}`}
            loading="lazy"
            className="img-fluid d-block mb-4 me-md-4"
            alt=""
          />
        </div>
        <div className="col-12 col-md-7">
          <div className="ms-0 ms-md-4">
            <h3
              className="fs-28 lh-30"
              dangerouslySetInnerHTML={{ __html: about_strategy?.title_two }}
            />
            <div
              className="fs-16 lh-30"
              dangerouslySetInnerHTML={{
                __html: about_strategy?.description_two,
              }}
            />
            {/* <ul>
              <li className="fs-16">
                Resilience, continuity and innovation for long-term business
                performance and growth
              </li>
            </ul>
            <p className="fs-16">
              We will continue to grow our business sustainably and innovate for
              our customers needs,{" "}
            </p>
            <h4 className="fs-16 fw-bold">KPIs and target</h4>
            <p className="fs-16 fw-bold">KPIs</p>
            <ul className="fs-16">
              <li>Tenancies</li>
              <li>Tenancies ration</li>
              <li>Tenancies ration for new BTS</li>
            </ul>
            <h4 className="fw-bold">Targets</h4>
            <ul className="fs-16 fw-bold">
              <li>
                Achieve an average one-minute downtime per tower by the end of
                2025
              </li>
              <li>46% carbon reduction per tenant by 2030</li>
            </ul> */}
          </div>
        </div>
      </section>
      <section>
        <p
          className="fs-16 mt-3"
          dangerouslySetInnerHTML={{ __html: about_strategy?.footer }}
        />
      </section>
    </section>
  );
};

export default Strategy;
